'use client';
// TODO линковка типов к документации функций
/**
 * Набор параметров функции `randomId`.
 * */ /**
 * Генерирует случайную строку указанной длины.
 * @param options - Набор параметров
 * @returns Случайная строка
 * */ function randomId(options) {
    var _ref = options || {}, _ref_length = _ref.length, length = _ref_length === void 0 ? 8 : _ref_length, _ref_radix = _ref.radix, radix = _ref_radix === void 0 ? 36 : _ref_radix, _ref_prefix = _ref.prefix, prefix = _ref_prefix === void 0 ? "" : _ref_prefix;
    var randomString = Math.random().toString(radix).slice(2, 2 + length);
    return "" + prefix + randomString;
}

export { randomId };
